module.exports = __webpack_public_path__ + "img/dewhot_logo.6999800e.png";